import style from './style.module.scss';

const Loader = () => <div className={style.loader} />

export default Loader;
